// Copyright 2026, Imprivata, Inc.  All rights reserved.

export enum AuthnLevel {
  ICP_SINGLE_FA = 'icp-single-fa',
  ICP_MFA = 'icp-mfa',
  ICP_PASSWORDLESS_MFA = 'icp-passwordless-mfa',
  ICP_MFA_IF_ENROLLED = 'icp-mfa-if-enrolled',
}

// AM_PORTAL shares the IAM instance ID on the server; the two names are kept
// distinct so call sites signal which domain (auth settings vs. portal admin
// settings) they target.
export enum InstanceKey {
  USS = 'feb45631-a492-4a1a-8297-417da1347bd5',
  IAM = '4c44699a-fc78-4b9e-8975-557d26f08bef',
  AM_PORTAL = '4c44699a-fc78-4b9e-8975-557d26f08bef',
}

export enum UserCanShowLiveFeedValue {
  ON = 'on',
  OFF = 'off',
}

const BaseSettingsValues = {
  featureKey: 'icp',
  configType: 'security',
  categoryName: 'authn-control',
  valueType: 'value',
};

export const SettingsValues = { ...BaseSettingsValues, name: 'mfa-type' };

export enum FieldNames {
  USS_VALUE = 'USS_VALUE',
  IAM_VALUE = 'IAM_VALUE',
  USS_ONE_FACTOR_VALUE = 'USS_ONE_FACTOR_VALUE',
  IAM_ONE_FACTOR_VALUE = 'IAM_ONE_FACTOR_VALUE',
  USER_CAN_SHOW_LIVE_FEED_VALUE = 'USER_CAN_SHOW_LIVE_FEED_VALUE',
}

export interface FormValues {
  [FieldNames.USS_VALUE]: AuthnLevel;
  [FieldNames.IAM_VALUE]: AuthnLevel;
  [FieldNames.IAM_ONE_FACTOR_VALUE]: boolean;
  [FieldNames.USS_ONE_FACTOR_VALUE]: boolean;
  [FieldNames.USER_CAN_SHOW_LIVE_FEED_VALUE]: boolean;
}

export const getSettingsTemplate = {
  featureKey: BaseSettingsValues.featureKey,
  categoryName: BaseSettingsValues.categoryName,
};

export const updateSettingsTemplate = {
  featureKey: SettingsValues.featureKey,
  configType: SettingsValues.configType,
  categoryName: SettingsValues.categoryName,
  name: SettingsValues.name,
  valueType: SettingsValues.valueType,
};

export const UserCanShowLiveFeedSettingValues = {
  ...BaseSettingsValues,
  instanceKey: InstanceKey.AM_PORTAL,
  name: 'user-can-show-live-feed',
};

export const updateUserCanShowLiveFeedSettingsTemplate = {
  featureKey: UserCanShowLiveFeedSettingValues.featureKey,
  configType: UserCanShowLiveFeedSettingValues.configType,
  categoryName: UserCanShowLiveFeedSettingValues.categoryName,
  instanceKey: UserCanShowLiveFeedSettingValues.instanceKey,
  name: UserCanShowLiveFeedSettingValues.name,
  valueType: UserCanShowLiveFeedSettingValues.valueType,
};
